module.exports = __webpack_public_path__ + "resources/img/img_security_chakramax_dac_m.76a943badac39d5e5869ae2c5af01056.png";